import { VehicleFilters } from "../features/Filters/VehicleFilters";

export const ArchivedVehiclesActions = () => {
  return (
    <div className="pb-3 pt-2">
      <VehicleFilters.ActiveFilters />
    </div>
  );
};
